var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px 0"}},[_vm._v(" 这是一个新的页面 item1 ")])}
var staticRenderFns = []

export { render, staticRenderFns }